(() => {
  if (customElements.get('featured-products-carousel-slider')) return;

  class FeaturedProductsCarouselSlider extends HTMLElement {
    constructor() {
      super();
      this.onSectionLoad = this.onSectionLoad.bind(this);
      this.onWindowLoad = this.onWindowLoad.bind(this);
      this.onResize = this.onResize.bind(this);
      this.swiper = null;
    }

    connectedCallback() {
      this.sliderEl = this.querySelector('[data-slider]');
      this.prevButton = this.querySelector('[data-prev]');
      this.nextButton = this.querySelector('[data-next]');

      if (!this.sliderEl) return;

      this.classList.remove('is-initialized');

      if (typeof Shopify !== 'undefined' && Shopify.designMode) {
        document.addEventListener('shopify:section:load', this.onSectionLoad);
      }

      window.addEventListener('resize', this.onResize);

      if (typeof Swiper === 'undefined') {
        window.addEventListener('load', this.onWindowLoad, { once: true });
        return;
      }

      this.initSwiper();
    }

    disconnectedCallback() {
      if (typeof Shopify !== 'undefined' && Shopify.designMode) {
        document.removeEventListener('shopify:section:load', this.onSectionLoad);
      }

      window.removeEventListener('load', this.onWindowLoad);
      window.removeEventListener('resize', this.onResize);
      this.destroySwiper();
    }

    onWindowLoad() {
      this.initSwiper();
    }

    onSectionLoad(event) {
      if (!event.target.contains(this)) return;
      this.destroySwiper();
      this.initSwiper();
    }

    onResize() {
      if (!this.swiper) return;
      this.applySlidesOffsetAfter(this.swiper);
      this.swiper.update();
    }

    applySlidesOffsetAfter(swiper) {
      if (!swiper?.params) return;

      const width = window.innerWidth;

      if (width >= 1024) {
        swiper.params.slidesOffsetAfter = 0;
        return;
      }

      if (width >= 768) {
        swiper.params.slidesOffsetAfter = 20;
        return;
      }

      swiper.params.slidesOffsetAfter = 16;
    }

    initSwiper() {
      if (typeof Swiper === 'undefined' || this.swiper || !this.sliderEl) return;

      const slideCount = this.sliderEl.querySelectorAll('.swiper-slide').length;
      if (!slideCount) return;

      this.swiper = new Swiper(this.sliderEl, {
        slidesPerView: 1.441,
        slidesPerGroup: 1,
        spaceBetween: 16,
        breakpointsInverse: true,
        watchOverflow: true,
        allowTouchMove: slideCount > 1,
        navigation:
          slideCount > 1
            ? {
                prevEl: this.prevButton,
                nextEl: this.nextButton,
              }
            : false,
        breakpoints: {
          600: {
            slidesPerView: 2.2,
            slidesPerGroup: 1,
            spaceBetween: 20,
          },
          768: {
            slidesPerView: 2.5,
            slidesPerGroup: 1,
            spaceBetween: 20,
          },
          1024: {
            slidesPerView: 3,
            slidesPerGroup: 1,
            spaceBetween: 0,
          },
          1300: {
            slidesPerView: 4,
            slidesPerGroup: 1,
            spaceBetween: 0,
          },
        },
        on: {
          breakpoint: () => {
            if (!this.swiper) return;
            this.applySlidesOffsetAfter(this.swiper);
            this.swiper.update();
          },
        },
      });

      this.applySlidesOffsetAfter(this.swiper);
      requestAnimationFrame(() => {
        this.swiper?.update();
        this.classList.add('is-initialized');
      });
    }

    destroySwiper() {
      if (!this.swiper) return;

      this.swiper.destroy(true, true);
      this.swiper = null;
      this.classList.remove('is-initialized');
    }
  }

  customElements.define('featured-products-carousel-slider', FeaturedProductsCarouselSlider);
})();
